import debounce from 'debounce';
import { createStore } from 'redux';
import stringify from 'fast-safe-stringify'

import Reducers from 'RLX/State/Reducers';
import { saveChanges } from 'RLX/State/Content/ContentActions'
import { LOG_STATE_CHANGES, AUTOSAVE_ENABLED } from 'RLX/Config';

const RLXStore = createStore(Reducers);

if (LOG_STATE_CHANGES) RLXStore.subscribe(() => {
  const AppState = RLXStore.getState();
  console.debug('- - - - - - - - - - - - - - - - - - - - - - -');
  console.debug(stringify(AppState, null, '  '));
  console.debug('- - - - - - - - - - - - - - - - - - - - - - -');
});

if (AUTOSAVE_ENABLED) RLXStore.subscribe(debounce(saveChanges, 1000));


export default RLXStore;



// WEBPACK FOOTER //
// ./client/RLX/State/Store.js